import { FC, ReactElement, ReactNode, useEffect } from 'react';
import styles from './Modal.module.scss';
import { CloseCross } from './CloseCross/CloseCross';
import { useDispatch } from '../../hooks';
import { setModalName } from '../../redux/app.slice';

interface ICloseCross {
    onClose: () => void;
    showAfter?: number;
}

interface IModalProps {
    name: string | null;
    title?: string;
    message: string | ReactNode;
    icon?: string;
    button: ReactElement | ReactElement[];
    footer?: ReactNode;
    closeCross?: ICloseCross;
}

export const Modal: FC<IModalProps> = ({ name, title, message, button, footer, icon, closeCross = null }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (name !== null)
            dispatch(setModalName(name));
    }, [dispatch, name]);

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                {closeCross && (
                    <CloseCross onClose={closeCross.onClose} showAfter={closeCross.showAfter} />
                )}

                {icon && (
                    <img
                        src={icon}
                        alt="icon"
                        className={styles.icon}
                    />
                )}

                {title && (
                    <div className={styles.title}>
                        {title}
                    </div>
                )}
                
                <div className={styles.message}>
                    {message}
                </div>
                
                <div className={styles.buttonCont}>
                    {Array.isArray(button) ? button.map(button => button) : button}
                </div>

                {footer && (
                    <div className={styles.footer}>
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};